export default {
  "src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HealthReport.index.c1":'Report Name',
  "src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HealthReport.index.c2":'Report Time',
  "src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HealthReport.index.c3":'Status',
  "src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HealthReport.index.c4":'Creator',
  "src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HealthReport.index.c5":'Generated Time',
  "src.pages.Customer.PersonalHealthReport.components.DownLoadModal.c1":'Download Report',
  "src.pages.Customer.PersonalHealthReport.components.DownLoadModal.c2":'Copy All Links',
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c1":"label",
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c2":"Generate a Report",
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c3":"Template",
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c4":"Report Time",
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c5":"Personnel List",
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c6":"Please add the personnel list",
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c7":"Login phone number",
  "src.components.ExportPersonalReportModal.index.c1":"Generate health report",
  "src.components.ExportPersonalReportModal.index.c2":"Generate template",
  "src.components.ExportPersonalReportModal.index.c3":"Generation by template",
  "src.components.ExportPersonalReportModal.index.c4":"First Step",
  "src.components.ExportPersonalReportModal.index.c5":"Second Step",
  "src.components.ExportPersonalReportModal.index.c6":"Third Step",
  "src.components.ExportPersonalReportModal.index.c7":"Set up personal report presentation content",
  "src.components.ExportPersonalReportModal.index.c8":"View and edit the specific content of personal report",
  "src.components.ExportPersonalReportModal.index.c9":"Finished",
  "src.components.ExportPersonalReportModal.index.c10":"Summarize",
  "src.components.ExportPersonalReportModal.index.c11":"Service Dynamics",
  "src.components.ExportPersonalReportModal.index.c12":"Basic Health Information",
  "src.components.ExportPersonalReportModal.index.c13":"Health Sign",
  "src.components.ExportPersonalReportModal.index.c14":"Health Assessment Profile",
  "src.components.ExportPersonalReportModal.index.c15":"Report Details",
  "src.components.ExportPersonalReportModal.index.c16":"Telephone Service",
  "src.components.ExportPersonalReportModal.index.c17":"SMS",
  "src.components.ExportPersonalReportModal.index.c18":"Wechat Service",
  "src.components.ExportPersonalReportModal.index.c19":"Offline Service",
  "src.components.ExportPersonalReportModal.index.c20":"Form of Service",
  "src.components.ExportPersonalReportModal.index.c21":"Life Style",
  "src.components.ExportPersonalReportModal.index.c22":"Clinical History",
  "src.components.ExportPersonalReportModal.index.c23":"Family History",
  "src.components.ExportPersonalReportModal.index.c24":"Medication Record",
  "src.components.ExportPersonalReportModal.index.c25":"Content",
  "src.components.ExportPersonalReportModal.index.c26":"Note: All information below is obtained from the Customer Details page",
  "src.components.ExportPersonalReportModal.index.c27":"Weight",
  "src.components.ExportPersonalReportModal.index.c28":"Blood Pressure",
  "src.components.ExportPersonalReportModal.index.c29":"Fasting Plasma Glucose",
  "src.components.ExportPersonalReportModal.index.c30":"Preprandial Blood Sugar",
  "src.components.ExportPersonalReportModal.index.c31":"Postprandial Blood Sugar",
  "src.components.ExportPersonalReportModal.index.c32":"Health sign",
  "src.components.ExportPersonalReportModal.index.c33":"Health Hut Report",
  "src.components.ExportPersonalReportModal.index.c34":"Detection Time",
  "src.components.ExportPersonalReportModal.index.c35":"Amount",
  "src.components.ExportPersonalReportModal.index.c36":"Organization ",
  "src.components.ExportPersonalReportModal.index.c37":"Detection Time",
  "src.components.ExportPersonalReportModal.index.c38":"Medical examination report",
  "src.components.ExportPersonalReportModal.index.c39":"Health assessment report",
  "src.components.ExportPersonalReportModal.index.c40":"Date interval",
  "src.components.ExportPersonalReportModal.index.c41":"Detail of health indicators",


}
